import { GOOGLE_STATIC_MAPS_KEY } from 'app/constants';

export const GoogleMapServiceModule = angular
    .module('app.services.utilities.googleMapService', [])
    .factory('googleMapService', () => {
        function setMap(address) {
            return {
                mapLink: `https://www.google.com/maps/place/${address}`,
                mapSrc: `https://maps.googleapis.com/maps/api/staticmap?center=${address}&scale=2&zoom=14&maptype=roadmap&markers=${address}&key=${GOOGLE_STATIC_MAPS_KEY}` // eslint-disable-line max-len
            };
        }

        return {
            setMap
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/googleMap.service.js